import { registerWithEmailAndPassword } from "../../api/signup";

export const registerUserWithEmailAndPasswordCredentials = async (payload: any) => {
  const response = await registerWithEmailAndPassword(payload);
  return response;
}
